import React from "react";
import { LoadingText } from "@teamscheme/loading-text";
import styled, { css } from "styled-components";

const LoadingWrapper = styled.div<{ color?: string }>`
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.color
      ? css`
          background: ${props.color};
        `
      : ""}
`;

const LoadingPage = ({
  text = "Laster",
  color,
}: {
  text?: string;
  color?: string;
}) => (
  <LoadingWrapper color={color}>
    <LoadingText text={text} />
  </LoadingWrapper>
);

export default LoadingPage;
